module.exports = __webpack_public_path__ + "static/media/python-news.68535950.png";